// extracted by mini-css-extract-plugin
module.exports = {"cubespinner":"hero_cubespinner__k0Vd3","spincube":"hero_spincube__rve_Z","face1":"hero_face1__DEST0","face2":"hero_face2__SuEtT","face3":"hero_face3__VOpI2"};